/* Generated by ai2react v0.102.0 - 2021-09-14 03:50 */
/* ai file: 06-the-world.ai */

import { makeAi2React } from './src/index'
import img0 from './img/06-the-world-large.svg'
import img1 from './img/06-the-world-mobile.svg'

const styles = `
  #g-06-the-world-box ,
  #g-06-the-world-box .g-artboard {
    margin:0 auto;
  }
  #g-06-the-world-box p {
    margin:0;
  }
  #g-06-the-world-box .g-aiAbs {
    position:absolute;
  }
  #g-06-the-world-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-06-the-world-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-06-the-world-box .g-aiPointText p { white-space: nowrap; }
  #g-06-the-world-large {
    position:relative;
    overflow:hidden;
  }
  #g-06-the-world-large p {
    font-family:Inter;
    font-weight:400;
    line-height:13px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:11px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-06-the-world-large .g-pstyle0 {
    font-weight:800;
    line-height:23px;
    height:23px;
    letter-spacing:-0.02em;
    font-size:19px;
  }
  #g-06-the-world-large .g-pstyle1 {
    font-weight:700;
    line-height:12px;
    height:12px;
    letter-spacing:-0.02em;
    font-size:10px;
  }
  #g-06-the-world-large .g-pstyle2 {
    font-weight:700;
    line-height:12px;
    height:12px;
    letter-spacing:-0.019em;
    font-size:10px;
  }
  #g-06-the-world-large .g-pstyle3 {
    font-weight:700;
    line-height:14px;
    height:14px;
    letter-spacing:-0.019em;
    color:rgb(101,54,148);
  }
  #g-06-the-world-large .g-pstyle4 {
    height:13px;
  }
  #g-06-the-world-large .g-pstyle5 {
    line-height:12px;
    height:12px;
    font-size:10px;
  }
  #g-06-the-world-large .g-pstyle6 {
    line-height:12px;
    height:12px;
    font-size:10px;
    color:rgb(88,89,91);
  }
  #g-06-the-world-large .g-pstyle7 {
    line-height:11px;
    height:11px;
    letter-spacing:0em;
    font-size:9px;
    color:rgb(255,255,255);
  }
  #g-06-the-world-large .g-pstyle8 {
    line-height:12px;
    height:12px;
    letter-spacing:-0.03em;
    font-size:10px;
    color:rgb(88,89,91);
  }
  #g-06-the-world-large .g-pstyle9 {
    height:13px;
    letter-spacing:-0.03em;
  }
  #g-06-the-world-large .g-pstyle10 {
    line-height:14px;
    height:14px;
  }
  #g-06-the-world-large .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-06-the-world-large .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-06-the-world-large .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-06-the-world-large .g-cstyle3 {
    letter-spacing:-0.033em;
  }
  #g-06-the-world-large .g-cstyle4 {
    letter-spacing:-0.03em;
  }
  #g-06-the-world-large .g-cstyle5 {
    letter-spacing:-0.032em;
  }
  #g-06-the-world-large .g-cstyle6 {
    letter-spacing:-0.042em;
  }
  #g-06-the-world-large .g-cstyle7 {
    letter-spacing:-0.116em;
  }
  #g-06-the-world-large .g-cstyle8 {
    letter-spacing:-0.09em;
  }
  #g-06-the-world-large .g-cstyle9 {
    letter-spacing:-0.035em;
  }
  #g-06-the-world-large .g-cstyle10 {
    letter-spacing:-0.029em;
  }
  #g-06-the-world-large .g-cstyle11 {
    letter-spacing:-0.036em;
  }
  #g-06-the-world-large .g-cstyle12 {
    letter-spacing:-0.04em;
  }
  #g-06-the-world-large .g-cstyle13 {
    letter-spacing:-0.014em;
  }
  #g-06-the-world-large .g-cstyle14 {
    letter-spacing:-0.034em;
  }
  #g-06-the-world-large .g-cstyle15 {
    letter-spacing:-0.038em;
  }
  #g-06-the-world-large .g-cstyle16 {
    letter-spacing:-0.037em;
  }
  #g-06-the-world-large .g-cstyle17 {
    letter-spacing:-0.054em;
  }
  #g-06-the-world-large .g-cstyle18 {
    letter-spacing:-0.068em;
  }
  #g-06-the-world-large .g-cstyle19 {
    letter-spacing:-0.039em;
  }
  #g-06-the-world-large .g-cstyle20 {
    letter-spacing:-0.047em;
  }
  #g-06-the-world-large .g-cstyle21 {
    letter-spacing:-0.048em;
  }
  #g-06-the-world-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-06-the-world-mobile p {
    font-family:Inter;
    font-weight:400;
    line-height:12px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-06-the-world-mobile .g-pstyle0 {
    font-weight:800;
    line-height:23px;
    height:23px;
    letter-spacing:-0.02em;
    font-size:19px;
    text-align:justify;
  }
  #g-06-the-world-mobile .g-pstyle1 {
    font-weight:700;
    line-height:11px;
    height:11px;
    letter-spacing:-0.02em;
    font-size:9px;
    text-align:justify;
  }
  #g-06-the-world-mobile .g-pstyle2 {
    font-weight:700;
    line-height:13px;
    height:13px;
    letter-spacing:-0.019em;
    font-size:11px;
    text-align:justify;
    color:rgb(101,54,148);
  }
  #g-06-the-world-mobile .g-pstyle3 {
    font-weight:700;
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
    text-align:justify;
  }
  #g-06-the-world-mobile .g-pstyle4 {
    height:12px;
    text-align:justify;
  }
  #g-06-the-world-mobile .g-pstyle5 {
    line-height:11px;
    height:11px;
    font-size:9px;
    text-align:justify;
  }
  #g-06-the-world-mobile .g-pstyle6 {
    line-height:11px;
    height:11px;
    font-size:9px;
    text-align:justify;
    color:rgb(88,89,91);
  }
  #g-06-the-world-mobile .g-pstyle7 {
    line-height:10px;
    height:10px;
    letter-spacing:0em;
    font-size:8px;
    text-align:justify;
    color:rgb(255,255,255);
  }
  #g-06-the-world-mobile .g-pstyle8 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
    text-align:justify;
    color:rgb(88,89,91);
  }
  #g-06-the-world-mobile .g-pstyle9 {
    height:12px;
    letter-spacing:-0.03em;
    text-align:justify;
  }
  #g-06-the-world-mobile .g-pstyle10 {
    line-height:13px;
    height:13px;
    font-size:11px;
    text-align:justify;
  }
  #g-06-the-world-mobile .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-06-the-world-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-06-the-world-mobile .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-06-the-world-mobile .g-cstyle3 {
    letter-spacing:-0.033em;
  }
  #g-06-the-world-mobile .g-cstyle4 {
    letter-spacing:-0.03em;
  }
  #g-06-the-world-mobile .g-cstyle5 {
    letter-spacing:-0.032em;
  }
  #g-06-the-world-mobile .g-cstyle6 {
    letter-spacing:-0.042em;
  }
  #g-06-the-world-mobile .g-cstyle7 {
    letter-spacing:-0.116em;
  }
  #g-06-the-world-mobile .g-cstyle8 {
    letter-spacing:-0.09em;
  }
  #g-06-the-world-mobile .g-cstyle9 {
    letter-spacing:-0.035em;
  }
  #g-06-the-world-mobile .g-cstyle10 {
    letter-spacing:-0.029em;
  }
  #g-06-the-world-mobile .g-cstyle11 {
    letter-spacing:-0.036em;
  }
  #g-06-the-world-mobile .g-cstyle12 {
    letter-spacing:-0.04em;
  }
  #g-06-the-world-mobile .g-cstyle13 {
    letter-spacing:-0.014em;
  }
  #g-06-the-world-mobile .g-cstyle14 {
    letter-spacing:-0.034em;
  }
  #g-06-the-world-mobile .g-cstyle15 {
    letter-spacing:-0.038em;
  }
  #g-06-the-world-mobile .g-cstyle16 {
    letter-spacing:-0.068em;
  }
  #g-06-the-world-mobile .g-cstyle17 {
    letter-spacing:-0.039em;
  }
  #g-06-the-world-mobile .g-cstyle18 {
    letter-spacing:-0.047em;
  }
  #g-06-the-world-mobile .g-cstyle19 {
    letter-spacing:-0.048em;
  }

`

const html = props => `
<div id="g-06-the-world-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-06-the-world-large" class="g-artboard" style="width:800px; height:501px;" data-aspect-ratio="1.597" data-min-width="800">
<div style=""></div>
    <img id="g-06-the-world-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:5.4322%;margin-top:-13.2px;left:1.0024%;width:87px;">
      <p class="g-pstyle0"><span class="g-cstyle0">T</span>O<span class="g-cstyle0">P</span> 1<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:9.7767%;margin-top:-7px;left:50.0283%;width:42px;">
      <p class="g-pstyle1">País</p>
    </div>
    <div id="g-ai0-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:9.9763%;margin-top:-7px;left:79.332%;width:61px;">
      <p class="g-pstyle2">Puntaje </p>
    </div>
    <div id="g-ai0-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.2254%;margin-top:-8.2px;left:8.2706%;width:79px;">
      <p class="g-pstyle3"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.1759%;margin-top:-7px;left:1.6025%;width:70px;">
      <p class="g-pstyle1">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:12.1719%;margin-top:-7px;left:1.6025%;width:68px;">
      <p class="g-pstyle1">MU<span class="g-cstyle0">N</span>DIA<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai0-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.035%;margin-top:-7.4px;left:10.0349%;width:133px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Ox<span class="g-cstyle4">fo</span>rd<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.3595%;margin-top:-7px;left:43.9471%;width:115px;">
      <p class="g-pstyle5">O<span class="g-cstyle4">x</span>fo<span class="g-cstyle4">r</span>d, <span class="g-cstyle4">R</span>e<span class="g-cstyle4">i</span>no <span class="g-cstyle5">U</span><span class="g-cstyle4">n</span>id<span class="g-cstyle4">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.3595%;margin-top:-7px;left:66.2115%;width:44px;">
      <p class="g-pstyle6">9<span class="g-cstyle4">5</span><span class="g-cstyle6">,</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.2103%;margin-top:-6.2px;left:4.325%;width:28px;">
      <p class="g-pstyle7"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai0-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.6198%;margin-top:-7.4px;left:10.0349%;width:244px;">
      <p class="g-pstyle4">I<span class="g-cstyle4">n</span>st<span class="g-cstyle4">it</span>ut<span class="g-cstyle4">o</span> <span class="g-cstyle7">T</span><span class="g-cstyle4">e</span>c<span class="g-cstyle4">n</span>ol<span class="g-cstyle4">ó</span>gi<span class="g-cstyle4">co</span> de Cal<span class="g-cstyle4">i</span>f<span class="g-cstyle4">o</span>r<span class="g-cstyle4">ni</span>a <span class="g-cstyle4">(</span>CA<span class="g-cstyle8">L</span>T<span class="g-cstyle9">E</span>C<span class="g-cstyle4">H</span>)<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.9444%;margin-top:-7px;left:43.9471%;width:145px;">
      <p class="g-pstyle5">P<span class="g-cstyle4">a</span>sa<span class="g-cstyle4">d</span>ena, <span class="g-cstyle4">E</span>st<span class="g-cstyle4">a</span>d<span class="g-cstyle4">o</span>s <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>dos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.9444%;margin-top:-7px;left:66.1135%;width:44px;">
      <p class="g-pstyle8"><span class="g-cstyle10">9</span>5<span class="g-cstyle9">,</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.7951%;margin-top:-6.2px;left:4.2985%;width:30px;">
      <p class="g-pstyle7"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai0-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.2046%;margin-top:-7.4px;left:10.0349%;width:138px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Ha<span class="g-cstyle4">r</span>vard<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.3296%;margin-top:-7px;left:43.9471%;width:150px;">
      <p class="g-pstyle5">C<span class="g-cstyle4">a</span>mb<span class="g-cstyle4">ri</span>d<span class="g-cstyle4">g</span>e, Esta<span class="g-cstyle4">d</span>os <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>dos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.5292%;margin-top:-7px;left:66.1135%;width:44px;">
      <p class="g-pstyle8"><span class="g-cstyle10">9</span>5<span class="g-cstyle9">,</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.38%;margin-top:-6.2px;left:4.2985%;width:30px;">
      <p class="g-pstyle7"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai0-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.7895%;margin-top:-7.4px;left:10.0349%;width:141px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span><span class="g-cstyle5">S</span>ta<span class="g-cstyle3">n</span><span class="g-cstyle4">f</span>o<span class="g-cstyle4">r</span>d<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.9144%;margin-top:-7px;left:43.9471%;width:139px;">
      <p class="g-pstyle5"><span class="g-cstyle5">S</span>ta<span class="g-cstyle3">n</span>f<span class="g-cstyle4">o</span>rd, E<span class="g-cstyle4">s</span>t<span class="g-cstyle4">a</span>dos <span class="g-cstyle3">U</span>nido<span class="g-cstyle4">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.114%;margin-top:-7px;left:66.078%;width:45px;">
      <p class="g-pstyle6">9<span class="g-cstyle11">4</span><span class="g-cstyle12">,</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.9648%;margin-top:-6.2px;left:4.272%;width:30px;">
      <p class="g-pstyle7"><span class="g-cstyle0">4</span> </p>
    </div>
    <div id="g-ai0-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.3743%;margin-top:-7.4px;left:10.0349%;width:153px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Cambr<span class="g-cstyle4">i</span>dge<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.4992%;margin-top:-7px;left:43.9471%;width:134px;">
      <p class="g-pstyle5">C<span class="g-cstyle4">a</span>mb<span class="g-cstyle4">ri</span>d<span class="g-cstyle4">g</span>e, Re<span class="g-cstyle4">i</span>no <span class="g-cstyle5">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.6988%;margin-top:-7px;left:66.0695%;width:45px;">
      <p class="g-pstyle6">9<span class="g-cstyle11">4</span><span class="g-cstyle9">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.5496%;margin-top:-6.2px;left:4.3074%;width:30px;">
      <p class="g-pstyle7"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai0-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.9591%;margin-top:-7.4px;left:10.0349%;width:243px;">
      <p class="g-pstyle4">I<span class="g-cstyle4">n</span>st<span class="g-cstyle4">it</span>ut<span class="g-cstyle4">o</span> <span class="g-cstyle7">T</span><span class="g-cstyle4">e</span>c<span class="g-cstyle4">n</span>ol<span class="g-cstyle4">ó</span>gi<span class="g-cstyle4">co</span> de Ma<span class="g-cstyle4">s</span>sac<span class="g-cstyle4">h</span>u<span class="g-cstyle4">se</span>tt<span class="g-cstyle4">s </span>(MI<span class="g-cstyle13">T</span>)<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.0841%;margin-top:-7px;left:43.9471%;width:150px;">
      <p class="g-pstyle5">C<span class="g-cstyle4">a</span>mb<span class="g-cstyle4">ri</span>d<span class="g-cstyle4">g</span>e, Esta<span class="g-cstyle4">d</span>os <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>dos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.2837%;margin-top:-7px;left:66.0695%;width:45px;">
      <p class="g-pstyle6">9<span class="g-cstyle11">4</span><span class="g-cstyle9">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.1345%;margin-top:-6.2px;left:4.3074%;width:30px;">
      <p class="g-pstyle7"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai0-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.544%;margin-top:-7.4px;left:10.0349%;width:145px;">
      <p class="g-pstyle9"><span class="g-cstyle3">U</span><span class="g-cstyle10">n</span>i<span class="g-cstyle10">v</span>er<span class="g-cstyle10">s</span>i<span class="g-cstyle10">d</span>a<span class="g-cstyle10">d d</span>e <span class="g-cstyle10">P</span>ri<span class="g-cstyle10">n</span>ce<span class="g-cstyle10">to</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.6689%;margin-top:-7px;left:43.9471%;width:143px;">
      <p class="g-pstyle5">P<span class="g-cstyle4">r</span>in<span class="g-cstyle4">c</span>et<span class="g-cstyle4">o</span>n, Esta<span class="g-cstyle4">d</span>os <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>dos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.8685%;margin-top:-7px;left:66.1404%;width:45px;">
      <p class="g-pstyle6">9<span class="g-cstyle14">3</span><span class="g-cstyle11">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.7193%;margin-top:-6.2px;left:4.3162%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">7</span> </p>
    </div>
    <div id="g-ai0-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.1288%;margin-top:-7.4px;left:10.0349%;width:192px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Ca<span class="g-cstyle4">l</span>i<span class="g-cstyle4">f</span>o<span class="g-cstyle4">r</span>nia, B<span class="g-cstyle4">er</span><span class="g-cstyle15">k</span>el<span class="g-cstyle4">e</span>y<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.2538%;margin-top:-7px;left:43.9471%;width:139px;">
      <p class="g-pstyle5">B<span class="g-cstyle4">e</span>r<span class="g-cstyle16">k</span><span class="g-cstyle4">e</span>le<span class="g-cstyle17">y</span><span class="g-cstyle4">,</span> E<span class="g-cstyle4">s</span>ta<span class="g-cstyle4">d</span>os <span class="g-cstyle3">U</span>nido<span class="g-cstyle4">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.4534%;margin-top:-7px;left:66.1318%;width:44px;">
      <p class="g-pstyle8"><span class="g-cstyle10">9</span>2<span class="g-cstyle10">,</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.3041%;margin-top:-6.2px;left:4.2896%;width:30px;">
      <p class="g-pstyle7"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai0-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.5141%;margin-top:-7.4px;left:10.0349%;width:123px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span><span class="g-cstyle18">Y</span>a<span class="g-cstyle4">l</span>e<span class="g-cstyle4"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.8386%;margin-top:-7px;left:43.9471%;width:153px;">
      <p class="g-pstyle5">N<span class="g-cstyle4">e</span>w <span class="g-cstyle4">H</span>av<span class="g-cstyle4">e</span>n, Esta<span class="g-cstyle4">d</span>os <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>dos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:79.0382%;margin-top:-7px;left:66.0695%;width:45px;">
      <p class="g-pstyle6">9<span class="g-cstyle19">0</span><span class="g-cstyle4">,</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.8889%;margin-top:-6.2px;left:4.2896%;width:30px;">
      <p class="g-pstyle7"><span class="g-cstyle0">9</span> </p>
    </div>
    <div id="g-ai0-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.0989%;margin-top:-7.4px;left:10.0349%;width:137px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Ch<span class="g-cstyle4">ic</span>ag<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai0-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.4234%;margin-top:-7px;left:43.9471%;width:135px;">
      <p class="g-pstyle5">C<span class="g-cstyle4">h</span>ic<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span>, E<span class="g-cstyle4">s</span>ta<span class="g-cstyle4">d</span>os <span class="g-cstyle5">U</span><span class="g-cstyle4">n</span>id<span class="g-cstyle4">o</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai0-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.623%;margin-top:-7px;left:66.0963%;width:42px;">
      <p class="g-pstyle6">8<span class="g-cstyle20">9</span>,<span class="g-cstyle1">8</span></p>
    </div>
    <div id="g-ai0-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.4737%;margin-top:-6.2px;left:3.9855%;width:31px;">
      <p class="g-pstyle7"><span class="g-cstyle0">1</span>0</p>
    </div>
    <div id="g-ai0-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:94.2573%;margin-top:-8.2px;left:1.0114%;width:274px;">
      <p class="g-pstyle10">(<span class="g-cstyle4">*</span>) <span class="g-cstyle14">F</span>u<span class="g-cstyle4">e</span>n<span class="g-cstyle4">t</span>e: Time<span class="g-cstyle4">s </span><span class="g-cstyle21">W</span><span class="g-cstyle4">o</span>rl<span class="g-cstyle4">d</span> <span class="g-cstyle5">U</span><span class="g-cstyle4">n</span>i<span class="g-cstyle4">v</span>e<span class="g-cstyle4">rs</span>it<span class="g-cstyle4">y</span> Ra<span class="g-cstyle4">n</span>k<span class="g-cstyle4">in</span>gs 202<span class="g-cstyle1">2</span></p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-06-the-world-mobile" class="g-artboard" style="max-width: 320px;max-height: 468px" data-aspect-ratio="0.684" data-min-width="0" data-max-width="799">
<div style="padding: 0 0 146.25% 0;"></div>
    <img id="g-06-the-world-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:5.6015%;margin-top:-13.2px;left:1.881%;width:87px;">
      <p class="g-pstyle0"><span class="g-cstyle0">T</span>O<span class="g-cstyle0">P</span> 1<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.5923%;margin-top:-6.6px;left:0.8812%;width:66px;">
      <p class="g-pstyle1">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.1684%;margin-top:-7.3px;left:15.8282%;width:75px;">
      <p class="g-pstyle2"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.2333%;margin-top:-6.6px;left:76.7386%;width:58px;">
      <p class="g-pstyle3">Puntaje </p>
    </div>
    <div id="g-ai1-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.2333%;margin-top:-6.6px;left:55.0565%;width:41px;">
      <p class="g-pstyle1">País</p>
    </div>
    <div id="g-ai1-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:12.5153%;margin-top:-6.6px;left:0.8812%;width:65px;">
      <p class="g-pstyle1">MU<span class="g-cstyle0">N</span>DIA<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai1-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.7872%;margin-top:-12.9px;left:7.1283%;width:78px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d </p>
      <p class="g-pstyle4">d<span class="g-cstyle4">e </span>Ox<span class="g-cstyle4">fo</span>rd<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.7119%;margin-top:-6.6px;left:54.9568%;width:75px;">
      <p class="g-pstyle5"><span class="g-cstyle4">R</span>e<span class="g-cstyle4">i</span>no <span class="g-cstyle5">U</span><span class="g-cstyle4">n</span>id<span class="g-cstyle4">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.7119%;margin-top:-6.6px;left:78.6827%;width:42px;">
      <p class="g-pstyle6">9<span class="g-cstyle4">5</span><span class="g-cstyle6">,</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.5631%;margin-top:-5.9px;left:2.8549%;width:28px;">
      <p class="g-pstyle7"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai1-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.6249%;margin-top:-12.9px;left:7.1283%;width:134px;">
      <p class="g-pstyle4">I<span class="g-cstyle4">n</span>st<span class="g-cstyle4">it</span>ut<span class="g-cstyle4">o</span> <span class="g-cstyle7">T</span><span class="g-cstyle4">e</span>c<span class="g-cstyle4">n</span>ol<span class="g-cstyle4">ó</span>gi<span class="g-cstyle4">co</span> </p>
      <p class="g-pstyle4">de Cal<span class="g-cstyle4">i</span>f<span class="g-cstyle4">o</span>r<span class="g-cstyle4">ni</span>a <span class="g-cstyle4">(</span>CA<span class="g-cstyle8">L</span>T<span class="g-cstyle9">E</span>C<span class="g-cstyle4">H</span>)<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.1906%;margin-top:-6.6px;left:54.9568%;width:90px;">
      <p class="g-pstyle5"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">a</span>d<span class="g-cstyle4">o</span>s <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>dos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.4042%;margin-top:-6.6px;left:78.4544%;width:43px;">
      <p class="g-pstyle8"><span class="g-cstyle10">9</span>5<span class="g-cstyle9">,</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.2554%;margin-top:-5.9px;left:2.7933%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai1-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.1035%;margin-top:-12.9px;left:7.1283%;width:78px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d </p>
      <p class="g-pstyle4">d<span class="g-cstyle4">e </span>Ha<span class="g-cstyle4">r</span>vard<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.6692%;margin-top:-6.6px;left:54.9568%;width:90px;">
      <p class="g-pstyle5">Esta<span class="g-cstyle4">d</span>os <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>dos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.8829%;margin-top:-6.6px;left:78.4544%;width:43px;">
      <p class="g-pstyle8"><span class="g-cstyle10">9</span>5<span class="g-cstyle9">,</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.7341%;margin-top:-5.9px;left:2.7933%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai1-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.7958%;margin-top:-12.9px;left:7.1283%;width:78px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d </p>
      <p class="g-pstyle4">d<span class="g-cstyle4">e </span><span class="g-cstyle5">S</span>ta<span class="g-cstyle3">n</span><span class="g-cstyle4">f</span>o<span class="g-cstyle4">r</span>d<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.3615%;margin-top:-6.6px;left:54.9568%;width:90px;">
      <p class="g-pstyle5">E<span class="g-cstyle4">s</span>t<span class="g-cstyle4">a</span>dos <span class="g-cstyle3">U</span>nido<span class="g-cstyle4">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.3615%;margin-top:-6.6px;left:78.3717%;width:43px;">
      <p class="g-pstyle6">9<span class="g-cstyle11">4</span><span class="g-cstyle12">,</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.2127%;margin-top:-5.9px;left:2.7316%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">4</span> </p>
    </div>
    <div id="g-ai1-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.2744%;margin-top:-12.9px;left:7.1283%;width:88px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d </p>
      <p class="g-pstyle4">d<span class="g-cstyle4">e </span>Cambr<span class="g-cstyle4">i</span>dge<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.8401%;margin-top:-6.6px;left:54.9568%;width:75px;">
      <p class="g-pstyle5">Re<span class="g-cstyle4">i</span>no <span class="g-cstyle5">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.0538%;margin-top:-6.6px;left:78.3517%;width:43px;">
      <p class="g-pstyle6">9<span class="g-cstyle11">4</span><span class="g-cstyle9">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.905%;margin-top:-5.9px;left:2.814%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai1-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.7531%;margin-top:-12.9px;left:7.1283%;width:133px;">
      <p class="g-pstyle4">I<span class="g-cstyle4">n</span>st<span class="g-cstyle4">it</span>ut<span class="g-cstyle4">o</span> <span class="g-cstyle7">T</span><span class="g-cstyle4">e</span>c<span class="g-cstyle4">n</span>ol<span class="g-cstyle4">ó</span>gi<span class="g-cstyle4">co</span></p>
      <p class="g-pstyle4">de Ma<span class="g-cstyle4">s</span>sac<span class="g-cstyle4">h</span>u<span class="g-cstyle4">se</span>tt<span class="g-cstyle4">s </span>(MI<span class="g-cstyle13">T</span>)<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.3188%;margin-top:-6.6px;left:54.9568%;width:90px;">
      <p class="g-pstyle5">Esta<span class="g-cstyle4">d</span>os <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>dos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.5324%;margin-top:-6.6px;left:78.3517%;width:43px;">
      <p class="g-pstyle6">9<span class="g-cstyle11">4</span><span class="g-cstyle9">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.3837%;margin-top:-5.9px;left:2.814%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai1-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.659%;margin-top:-12.9px;left:7.1283%;width:81px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d </p>
      <p class="g-pstyle9"><span class="g-cstyle10">d</span>e <span class="g-cstyle10">P</span>ri<span class="g-cstyle10">n</span>ce<span class="g-cstyle10">to</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.0111%;margin-top:-6.6px;left:54.9568%;width:90px;">
      <p class="g-pstyle5">Esta<span class="g-cstyle4">d</span>os <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>dos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.0111%;margin-top:-6.6px;left:78.517%;width:43px;">
      <p class="g-pstyle6">9<span class="g-cstyle14">3</span><span class="g-cstyle11">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.8623%;margin-top:-5.9px;left:2.8345%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">7</span> </p>
    </div>
    <div id="g-ai1-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.1377%;margin-top:-12.9px;left:7.1283%;width:110px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e</span></p>
      <p class="g-pstyle4">Ca<span class="g-cstyle4">l</span>i<span class="g-cstyle4">f</span>o<span class="g-cstyle4">r</span>nia, B<span class="g-cstyle4">er</span><span class="g-cstyle15">k</span>el<span class="g-cstyle4">e</span>y<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.4897%;margin-top:-6.6px;left:54.9568%;width:90px;">
      <p class="g-pstyle5">E<span class="g-cstyle4">s</span>ta<span class="g-cstyle4">d</span>os <span class="g-cstyle3">U</span>nido<span class="g-cstyle4">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.7034%;margin-top:-6.6px;left:78.497%;width:43px;">
      <p class="g-pstyle8"><span class="g-cstyle10">9</span>2<span class="g-cstyle10">,</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.5546%;margin-top:-5.9px;left:2.7725%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai1-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.4026%;margin-top:-12.9px;left:7.1283%;width:75px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d</p>
      <p class="g-pstyle9"><span class="g-cstyle10">d</span>e <span class="g-cstyle16">Y</span><span class="g-cstyle10">a</span>l<span class="g-cstyle10">e</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.9683%;margin-top:-6.6px;left:54.9568%;width:90px;">
      <p class="g-pstyle5">Esta<span class="g-cstyle4">d</span>os <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>dos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:79.182%;margin-top:-6.6px;left:78.3517%;width:43px;">
      <p class="g-pstyle6">9<span class="g-cstyle17">0</span><span class="g-cstyle4">,</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:79.0332%;margin-top:-5.9px;left:2.7725%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">9</span> </p>
    </div>
    <div id="g-ai1-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.3086%;margin-top:-12.9px;left:7.1283%;width:78px;">
      <p class="g-pstyle4"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d </p>
      <p class="g-pstyle4">d<span class="g-cstyle4">e </span>Ch<span class="g-cstyle4">ic</span>ag<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai1-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.6606%;margin-top:-6.6px;left:54.9568%;width:88px;">
      <p class="g-pstyle5">E<span class="g-cstyle4">s</span>ta<span class="g-cstyle4">d</span>os <span class="g-cstyle5">U</span><span class="g-cstyle4">n</span>id<span class="g-cstyle4">o</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.6606%;margin-top:-6.6px;left:78.4143%;width:41px;">
      <p class="g-pstyle6">8<span class="g-cstyle18">9</span>,<span class="g-cstyle1">8</span></p>
    </div>
    <div id="g-ai1-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.5119%;margin-top:-5.9px;left:2.0644%;width:31px;">
      <p class="g-pstyle7"><span class="g-cstyle0">1</span>0</p>
    </div>
    <div id="g-ai1-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:94.5018%;margin-top:-7.3px;left:1.8336%;width:257px;">
      <p class="g-pstyle10">(<span class="g-cstyle4">*</span>) <span class="g-cstyle14">F</span>u<span class="g-cstyle4">e</span>n<span class="g-cstyle4">t</span>e: Time<span class="g-cstyle4">s </span><span class="g-cstyle19">W</span><span class="g-cstyle4">o</span>rl<span class="g-cstyle4">d</span> <span class="g-cstyle5">U</span><span class="g-cstyle4">n</span>i<span class="g-cstyle4">v</span>e<span class="g-cstyle4">rs</span>it<span class="g-cstyle4">y</span> Ra<span class="g-cstyle4">n</span>k<span class="g-cstyle4">in</span>gs 202<span class="g-cstyle1">2</span></p>
    </div>
  </div>


</div>
`

const containerId = 'g-06-the-world-box'
const namespace = 'g-'
const name = '06-the-world'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-09-14 03:50 */
